module.exports = __webpack_public_path__ + "images/switch_on_7538aa11efe30ab0cf0e74c5ee18c466.svg";